<!-- start banner Area -->
<!-- <section class="banner-area relative"
  id="home">
  <div class="overlay overlay-bg"></div>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center">
      <div class="about-content col-lg-12">
        <h1 class="text-white">
          Nos filiales
        </h1>
      </div>
    </div>
  </div>
</section> -->
<!-- End banner Area -->

<!-- Start blog-posts Area -->
<section class="blog-posts-area section-gap">
  <div class="">
    <div class="">
      <div class=" post-list blog-post-list" style="margin: auto; color: black;">
        <!-- Content of menu 'talents-plus-conseils-benin' -->
        <div class="single-post" *ngIf="submenu == 'talents-plus-conseils-benin'">
          <div class="container-xxl about " style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
    background-size: cover;">
            <div class="container">
              <div class="row g-0">
                <div class="col-lg-6">
                  <div class="h-100 d-flex align-items-center justify-content-center" style="min-height: 300px;">
                    <h1 class="customize-title" style="color: white;">Talents Plus Conseils Bénin </h1>
                  </div>
                </div>
                <div class="col-lg-6 pt-lg-3 mb-lg-5 wow fadeIn" data-wow-delay="0.5s">
                  <div class="bg-white rounded-top p-5 mt-lg-5">
                    <p class=" mb-2" style="font-size: 15px !important  ;text-align: justify;">Créée en février 2005,
                      TALENTS PLUS CONSEILS Bénin est spécialisé dans le conseil en management des Ressources Humaines
                      et possède une expérience
                      prouvée
                      en matière de :</p>
                    <ul style="font-weight:bold;">
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Formations, renforcement des
                        capacités et Coaching </li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Recrutement </li>

                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Assistance administrative et
                        organisationnelle</li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Gestion Externalisée des
                        ressources humaines</li>
                      <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Etude et développement d’outils RH
                      </li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>SIRH </li>
                    </ul>
                    <p class=" mb-3" style="font-size: 15px !important  ; text-align: justify;">Toutes prestations qui
                      permettent aux
                      Organisations d’être compétitives, d’attirer et de fidéliser leurs ressources humaines.</p>
                    <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;"
                      href="contact/benin-tpc">Contactez nous</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- About End -->
          <section class="about-section section-padding"
            style="padding: 20px 0px 20px; background: url('assets/img/back-about.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;"
            id="section_2">
            <div class="container ">
              <div class="prix-filiale row">
                <div class="col-lg-6 col-12">
                  <div class="about-text-wrap">
                    <div class="">
                      <div class="ms-4">
                        <img src="assets/img/prix.jpg" alt="" style="width: 100% !important;">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-12 mb-4 mb-lg-0">
                  <div class="services-info">
                    <h2 class=" customize-title" style="color: #FF5A00 !important;">Prix</h2>

                    <p class="text-blue">En 2008, le Cabinet s’est vu décerner à Genève <span
                        style="font-weight:bold; text-align: justify;">le prix ERA
                        international de la qualité et a vu sa position de leader en matière de management des
                        Ressources
                        Humaines confortée au Bénin et dans la sous-région.</span></p>

                    <p class="text-blue">En 2016, il a reçu <span style="font-weight:bold; text-align: justify;">le prix
                        ‘’BEST HUMAN
                        RESSOURCES CONSULTING AGENCY
                        WEST AFRICA’’. Il s’agit du prix du meilleur Cabinet de Ressources Humaines de l’Afrique
                        l’Ouest.
                      </span></p>

                    <p class="text-blue ">En 2018, Talents Plus Conseils a reçu <span
                        style="font-weight:bold; text-align: justify;">le
                        prix de l’Entreprise la
                        plus dynamique du secteur de la GRH au Bénin et dans l’UEMOA’’.</span>
                      Ce leadership s’observe par la confiance que plusieurs structures dont de grandes institutions
                      internationales ont bien voulu placer en nous, en nous confiant la conduite de diverses missions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div class="container-xxl py-5">
            <div class="container">
              <div class="row g-5">
                <div class="col-lg-8 wow fadeInUp" data-wow-delay="0.1s">
                  <h2 class="customize-title" style="color: #00027d;">Les principaux outils</h2>
                  <p>Talents Plus Conseils Bénin propose de nombreux outils dont les principaux sont :

                  <div class="row">
                    <div class="col-lg-6">
                      <ul style="font-weight:bold;">
                        <li> <img src="assets/img/rh/check.png" class="list-check" alt=""> Recrutement
                          complet
                        </li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt="">Chasse de tête</li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt="">Mise à disposition
                          de
                          CVs</li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt="">Tests
                          psychotechniques
                          électroniques</li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt="">Fiche de définition
                          et
                          de description de poste
                        </li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt="">Système d’évaluation
                          des performances
                        </li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt="">Système de
                          développement des compétences
                        </li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt=""> GPEC</li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt=""> Job family (famille
                          de métier): commercial, technicien, etc...</li>

                      </ul>
                    </div>
                    <div class="col-lg-6">
                      <ul style="font-weight:bold;">
                        <li> <img src="assets/img/rh/check.png" class="list-check" alt="">Système de gestion
                          des non performants</li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt="">Système de
                          motivation
                        </li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt="">Rémunération :
                          grille
                          de salaire, système de rémunération au rendement</li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt="">Enquête de
                          satisfaction du personnel</li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt="">Audit social et
                          organisationnel</li>
                        <li> <img src="assets/img/rh/check.png" class="list-check" alt="">Bilan social
                        </li>
                        <li><img src="assets/img/rh/check.png" class="list-check" alt="">Système de
                          communication interne</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
                  <img src="assets/img/outils.jpg" style="width: 100%;" alt="">
                </div>
              </div>
            </div>
          </div>

          <section class="ett"
            style="padding: 20px 0px 20px; background: url('assets/img/back-about.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
            <div class="container">
              <div class="row mt-5 ">
                <div class="col-12 col-sm-7 col-lg-7 order-2">
                  <div>
                    <h2 class="customize-title" style="color: #00027d;">Le Chef de mission </h2>
                    <p style="text-align: justify;">Il totalise aujourd’hui plus de 27 ans d’expériences éprouvées dans
                      le développement des outils
                      GRH et le transfert des
                      compétences dans ce domaine. Titulaire d’un DESS en GRH et Organisation, il a développé et forme
                      les cadres et le
                      personnel RH de plusieurs entreprises. Formateur & coach senior, il a animé une cinquantaine de
                      formation en gestion des
                      ressources humaines et développement du potentiel humain. Il a conduit plus de 3000 entretiens de
                      recrutement et a à son
                      actif plusieurs références telles que ECOBANK (Bénin, Niger), BAT au Niger, Bénin et Togo,
                      SONAPRA,
                      GIZ, Plan Bénin,
                      TOTAL, CHEVRON, BSIC, Ministères (développement rural et finances) au Bénin, MTN BENIN, Africaine
                      des Assurances, BCEAO,
                      Groupe SFP, SONEB, SBEE, etc.
                    </p>
                    <p style="font-weight: bold;">Avec vous, nous affinons notre expertise.</p>
                    <h3>ALFRED BIAOU</h3>
                    <div class="social-footer" style="margin-bottom: 40px;">

                      <a target="_blank" href="#"><img src="assets/img/mail.svg" height="40"></a>
                      <a target="_blank" href="#">abiaou@talentsplusafrique.com</a>

                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-5 col-lg-5 order-1"
                  style="display: flex;justify-content: space-around; align-items: flex-start;"><img
                    style="width: 63%;border-radius: 10%;" src="assets/img/20.jpg"></div>
              </div>
            </div>
          </section>
          <app-confiance></app-confiance>

        </div>

        <!-- Content of menu 'talents-plus-ett-benin' -->
        <div class="single-post" *ngIf="submenu == 'talents-plus-ett-benin'">

          <!-- About Start -->
          <div class="container-xxl about " style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                                    background-size: cover;">
            <div class="container">
              <div class="row g-0">
                <div class="col-lg-6">
                  <div class="h-100 d-flex align-items-center justify-content-center" style="min-height: 300px;">
                    <h1 class="customize-title" style="color: white;">Talents Plus ETT Bénin </h1>
                  </div>
                </div>
                <div class="col-lg-6 pt-lg-3 mb-lg-5 wow fadeIn" data-wow-delay="0.5s">
                  <div class="bg-white rounded-top p-3 mt-lg-5">
                    <p class=" mb-2" style="font-size: 15px !important  ;">Entreprise de Travail Temporaire créée en
                      février
                      2009, TALENTS PLUS ETT est une filiale du Groupe
                      Talents Plus. TALENTS PLUS ETT est spécialisée dans le recrutement et la mise à disposition de
                      personnel temporaire</p>

                    <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;"
                      href="contact/benin-ett">Contactez
                      nous</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- About End -->

          <section class="ett" style="margin:50px auto;">
            <div class="container">
              <div class="row">
                <div class="col-12 col-sm-6 col-lg-6" style="margin: auto;">
                  <h2 class="customize-title" style="color: #FF5A00;">Mode de fonctionnement</h2>
                  <p>A travers un partenariat triangulaire, l’Agence apporte des solutions flexibles, réactives et
                    professionnelles au défi d’accroissement temporaire des effectifs ou à la politique
                    d’externalisation de certaines fonctions des sociétés et institutions au Bénin.

                  <ul style="font-weight:bold;">
                    <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Contrat de prestation de service
                      entre l’agence et l’entreprise utilisatrice</li>
                    <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Contrat de travail temporaire ou de
                      mission entre l’agence et l’employé</li>
                    <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Mise à disposition de la force de
                      travail et utilisation optimale et responsable de cette
                      force de travail entre l’employé et l’entreprise utilisatrice</li>
                  </ul>
                  <!-- </p> -->

                </div>
                <div class="col-12 col-sm-6 col-lg-6"><img style="width:100%;" src="assets/img/ett-exp.svg"></div>
                <div class="col-12 col-sm-5 col-lg-5"><img style="width: 100%; border-radius: 15px;"
                    src="assets/img/img-ett-2.jpg"></div>
                <div class="col-12 col-sm-6 col-lg-6" style="margin: auto;">
                  <h2 class="customize-title" style="color: #FF5A00;">Exigences</h2>
                  <p>L’employeur de l’intérimaire est l’agence. L’agence a l’obligation de respecter les réglementations
                    et lois du travail au Bénin :
                  <ul style="font-weight:bold;">
                    <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Déclaration à la CNSS et paiement
                      des cotisations</li>
                    <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Déclaration fiscale et paiement des
                      charges fiscales à bonne date</li>
                    <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Couverture médicale</li>
                    <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Assurance responsabilité civile</li>
                  </ul>
                  <!-- </p> -->
                </div>
              </div>
            </div>
          </section>
          <section
            style="padding: 70px 0px 60px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
            <div class="container">
              <div class="row">
                <div class="col-12 col-sm-6 col-lg-6" style="margin: auto;">
                  <h2 class="customize-title" style="color : #fff;">Près d'une vingtaine de pays nous ont adoptés:</h2>
                  <!-- <h2 style="color : #fff;">Pays où nous sommes intervenus</h2> -->
                </div>
                <div class="col-6 col-sm-2 col-lg-2" style="margin: auto;">
                  <p style="color: #fff;">
                    <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> BENIN
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> BURKINA-FASO
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> COTE D’IVOIRE
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GUINEE BISSAU
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GUINEE CONAKRY
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> GHANA

                  </p>
                </div>
                <div class="col-6 col-sm-2 col-lg-2" style="margin: auto;">
                  <p style="color: #fff;">
                    <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> MALI
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> MAURITANIE
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> TOGO
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CENTRAFRIQUE
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> CAMEROUN
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> SIERRA-LEONE

                  </p>
                </div>
                <div class="col-12 col-sm-2 col-lg-2" style="margin: auto;">
                  <p style="color: #fff;">
                    <img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> SENEGAL
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> NIGER
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> NIGERIA
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> TCHAD
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> HAITI
                    <br><img src="assets/img/rh/check.png" width="20" class="list-check" alt=""> KENYA

                  </p>
                </div>

              </div>
            </div>
          </section>
          <section class="ett" style="margin:50px auto;">
            <div class="container">
              <div class="row">
                <div class="col-12 col-sm-7 col-lg-7 order-2">
                  <div>

                    <h2 class="customize-title" style="color: #00027d;">
                      Chef de mission </h2>
                    <p>Titulaire d’une Maitrise en sociologie et d’un Master en Gestion des
                      Ressources
                      Humaines, elle totalise plus de 17
                      années d’expériences dans la gestion des ressources humaines.
                    </p>
                    <p style="font-weight: bold;">Avec vous, nous affinons notre expertise.</p>
                    <h3>BÉNÉDICTE OKIRI</h3>
                    <div class="social-footer" style="margin-bottom: 40px;">
                      <a target="_blank" href="#"><img src="assets/img/linkdin_color.PNG" height="35"
                          style="margin-right: 20px;    fill: #FF5A00; "></a>
                      <a target="_blank" href="#"><img src="assets/img/mail.svg" height="40"></a>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-5 col-lg-5 order-1" style=""><img style="width: 50%;    border-radius: 10%;"
                    src="assets/img/dt.webp"></div>
              </div>
            </div>
          </section>
          <app-confiance></app-confiance>
        </div>

        <!-- Content of menu 'talents-plus-ett-togo' -->
        <div class="single-post" *ngIf="submenu == 'talents-plus-ett-togo'">
          <!-- About Start -->
          <div class="container-xxl about " style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                                            background-size: cover;">
            <div class="container">
              <div class="row g-0">
                <div class="col-lg-6">
                  <div class="h-100 d-flex align-items-center justify-content-center" style="min-height: 300px;">
                    <h1 class="customize-title" style="color: white;">Talents Plus ETT Togo </h1>
                  </div>
                </div>
                <div class="col-lg-6 pt-lg-3 mb-lg-5 wow fadeIn" data-wow-delay="0.5s">
                  <div class="bg-white rounded-top p-3 mt-lg-5">

                    <p class=" mb-2" style="font-size: 15px !important  ;">Agence de Travail Temporaire créée en février
                      2009, TALENTS PLUS ETT est une filiale du Groupe
                      Talents Plus. TALENTS PLUS ETT est spécialisée dans le recrutement et la mise à disposition de
                      personnel temporaire</p>

                    <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;"
                      href="contact/togo">Contactez
                      nous</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- About End -->

          <section class="ett" style="margin:50px auto;">
            <div class="container">
              <div class="row">
                <div class="col-12 col-sm-6 col-lg-6" style="margin: auto;">
                  <h2 class="customize-title" style="color: #FF5A00;">Mode de fonctionnement</h2>
                  <p>A travers un partenariat triangulaire, l’Agence apporte des solutions flexibles, réactives et
                    professionnelles au défi d’accroissement temporaire des effectifs ou à la politique
                    d’externalisation de certaines fonctions des sociétés et institutions au Bénin.

                  <ul style="font-weight:bold;">
                    <li>Contrat de prestation de service entre l’agence et l’entreprise utilisatrice</li>
                    <li>Contrat de travail temporaire ou de mission entre l’agence et l’employé</li>
                    <li>Mise à disposition de la force de travail et utilisation optimale et responsable de cette
                      force de travail entre l’employé et l’entreprise utilisatrice</li>
                  </ul>
                  <!-- </p> -->

                </div>
                <div class="col-12 col-sm-6 col-lg-6"><img style="width:100%;" src="assets/img/ett-exp.svg"></div>
                <div class="col-12 col-sm-5 col-lg-5"><img style="width: 100%; border-radius: 15px;"
                    src="assets/img/ett.jpg"></div>
                <div class="col-12 col-sm-6 col-lg-6" style="margin: auto;">
                  <h2 class="customize-title" style="color: #FF5A00;">Exigences</h2>
                  <p>L’employeur de l’intérimaire est l’agence. L’agence a l’obligation de respecter les réglementations
                    et lois du travail au Bénin :
                  <ul style="font-weight:bold;">
                    <li>Déclaration à la CNSS et paiement des cotisations</li>
                    <li>Déclaration fiscale et paiement des charges fiscales à bonne date</li>
                    <li>Couverture médicale</li>
                    <li>Assurance responsabilité civile</li>
                  </ul>
                  <!-- </p> -->
                </div>
              </div>
            </div>
          </section>
          <section class="ett" style="margin:50px auto;">
            <div class="container">
              <div class="row mt-5 ">
                <div class="col-12 col-sm-7 col-lg-7 order-1">
                  <div>
                    <h2 class="customize-title" style="color: #00027d;">Le Chef de mission </h2>
                    <p style="text-align: justify;">Il totalise aujourd’hui plus de 27 ans d’expériences éprouvées dans
                      le développement des outils
                      GRH et le transfert des
                      compétences dans ce domaine. Titulaire d’un DESS en GRH et Organisation, il a développé et forme
                      les cadres et le
                      personnel RH de plusieurs entreprises. Formateur & coach senior, il a animé une cinquantaine de
                      formation en gestion des
                      ressources humaines et développement du potentiel humain. Il a conduit plus de 3000 entretiens de
                      recrutement et a à son
                      actif plusieurs références telles que ECOBANK (Bénin, Niger), BAT au Niger, Bénin et Togo,
                      SONAPRA,
                      GIZ, Plan Bénin,
                      TOTAL, CHEVRON, BSIC, Ministères (développement rural et finances) au Bénin, MTN BENIN, Africaine
                      des Assurances, BCEAO,
                      Groupe SFP, SONEB, SBEE, etc.
                    </p>
                    <p style="font-weight: bold;">Avec vous, nous affinons notre expertise.</p>
                    <h3>ALFRED BIAOU</h3>
                    <div class="social-footer" style="margin-bottom: 40px;">

                      <a target="_blank" href="#"><img src="assets/img/mail.svg" height="40"></a>

                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-5 col-lg-5 order-2"
                  style="display: flex;justify-content: space-around; align-items: flex-start;"><img
                    style="width: 63%;border-radius: 10%;" src="assets/img/11.png"></div>
              </div>
            </div>
          </section>
          <app-confiance></app-confiance>
        </div>

        <!-- Content of menu 'talents-plus-conseils-mali' -->
        <div class="single-post" *ngIf="submenu == 'talents-plus-conseils-mali'">
          <!-- About Start -->
          <div class="container-xxl about " style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
              background-size: cover;">
            <div class="container">
              <div class="row g-0">
                <div class="col-lg-6">
                  <div class="h-100 d-flex align-items-center justify-content-center" style="min-height: 300px;">
                    <h1 class="customize-title" style="color: white;">Talents Plus Conseils Mali </h1>
                  </div>
                </div>
                <div class="col-lg-6 pt-lg-3 mb-lg-5 wow fadeIn" data-wow-delay="0.5s">
                  <div class="bg-white rounded-top p-3 mt-lg-5">
                    <p class=" mb-2" style="font-size: 15px !important  ;"> Créée en février 2008, TALENTS PLUS CONSEILS
                      Mali
                      est spécialisé dans le conseil en management des Ressources Humaines et possède une expérience
                      prouvée
                      en matière de :</p>
                    <ul style="font-weight:bold;">
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Formations, renforcement des
                        capacités et Coaching </li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Recrutement </li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Portage </li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Mise à disposition de personnel de
                      </li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Externalisation</li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Assistance administrative et
                        organisationnelle</li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Gestion Externalisée des
                        ressources humaines</li>
                      <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Etude et développement d’outils RH
                      </li>
                    </ul>
                    <p class=" mb-3" style="font-size: 15px !important  ;">Toutes prestations qui permettent aux
                      Organisations d’être compétitives, d’attirer et de fidéliser leurs ressources humaines.</p>
                    <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;"
                      href="contact/mali">Contactez
                      nous</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- About End -->
          <section class="ett" style="margin:50px auto;">
            <div class="container">
              <div class="row">
                <div class="col-12 col-sm-7 col-lg-7 order-2" style="margin: auto;">
                  <div>

                    <h2 class="customize-title" style="color: #00027d;">A propos</h2>
                    <p style="text-align: justify;">Le cabinet Talents Plus
                      Conseils Mali est une
                      filiale du Groupe Talents Plus spécialisé en Gestion des Ressources Humaines. Il œuvre pour la
                      mise en place et le
                      développement du capital humain de nombreuses organisations tant au Mali, en Côte d'Ivoire, au
                      Bénin que dans la
                      sous-région ouest
                      Africaine.</p>
                  </div>
                </div>
                <div class="col-12 col-sm-5 col-lg-5 order-1" style="margin: auto;"><img
                    style="width: 100%;    border-radius: 10%;" src="assets/img/conseils.jpg"></div>
              </div>
            </div>
          </section>

          <section class="about-section section-padding"
            style="padding: 20px 0px 20px; background: url('assets/img/back-about.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;"
            id="section_2">
            <div class="container">
              <div class="prix-filiale row">
                <div class="col-lg-6 col-12 mb-4 mb-lg-0 ">
                  <div class="services-info">
                    <p class="customize-title" style="color: #FF5A00 !important;">Prix</p>
                    <p class="text-blue">En 2008, le Cabinet s’est vu décerner à Genève <span
                        style="font-weight:bold; text-align: justify;">le prix
                        ERA
                        international de la qualité et a vu sa position de leader en matière de management des
                        Ressources
                        Humaines confortée au Bénin et dans la sous-région.</span></p>

                    <p class="text-blue " style="text-align: justify;">En 2016, il a reçu <span
                        style="font-weight:bold;">le prix ‘’BEST HUMAN
                        RESSOURCES CONSULTING AGENCY
                        WEST AFRICA’’. Il s’agit du prix du meilleur Cabinet de Ressources Humaines de l’Afrique
                        l’Ouest.
                      </span></p>

                    <p class="text-blue " style="text-align: justify;">En 2018, Talents Plus Conseils a reçu <span
                        style="font-weight:bold;">le
                        prix de l’Entreprise la
                        plus dynamique du secteur de la GRH au Bénin et dans l’UEMOA’’.</span>
                      Ce leadership s’observe par la confiance que plusieurs structures dont de grandes institutions
                      internationales ont bien voulu placer en nous, en nous confiant la conduite de diverses missions.
                    </p>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="about-text-wrap">
                    <!-- <img src="assets/img/abouts.jpg" class="about-image img-fluid"> -->
                    <div class="">
                      <div class="ms-4">
                        <img src="assets/img/prix.jpg" alt="" style="width: 100% !important;">
                        <!-- <h3>a happy moment</h3>
                                    <p class="mb-0">your amazing festival experience with us</p> -->
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>

          <section
            style="padding: 20px 0px 20px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat; color: #fff;">

            <div class="container">
              <H2 class="customize-title" style="text-align: center;margin-bottom: 20px;">Nos pôles d'expertise</H2>
              <div class="row">
                <div class="col-lg-4">
                  <ul style="font-weight:bold;">
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Recrutement complet</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Formation </li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Développemenr des outils
                      de GRH</li>
                  </ul>
                </div>
                <div class="col-lg-4">
                  <ul style="font-weight:bold;">
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Rémunération
                    </li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Assistance en GRH</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Conseil et Assistance
                      aux Entreprises</li>

                  </ul>
                </div>
                <div class="col-lg-4">
                  <ul style="font-weight:bold;">

                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Outsourcing et Intérim
                    </li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Audit social et
                      organisationnel</li>

                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section class="nos-clients">
            <h2 class="customize-title"
              style="text-align: center; margin-bottom: 50px; font-weight: bold; color: rgb(0, 2, 125);">Nos secteurs
            </h2>
            <div class="container">

              <div class="row justify-content-center">
                <div class="col-12 col-sm-3 col-lg-2">
                  <div class=" client-hover">
                    <p class="bold">ONGs &amp; Institutions Internationales</p>
                  </div>
                </div>
                <!-- <div class="col-12 col-sm-3 col-lg-2">
                  <div class=" client-hover">
                    <p class="bold">Secteur Bancaire &amp; Assurance</p>
                    <h1 style="text-align: center; ">+18</h1>
                    <h3 style="text-align: center;">Clients</h3>
                  </div>
                </div> -->
                <div class="col-12 col-sm-3 col-lg-2">
                  <div class=" client-hover">
                    <p class="bold">Enseignement</p>
                  </div>
                </div>
                <div class="col-12 col-sm-3 col-lg-3">
                  <div class=" client-hover">
                    <p class="bold">Secteur Télécommunications</p>
                  </div>
                </div>
                <div class="col-12 col-sm-4 col-lg-2">
                  <div class=" client-hover">
                    <p class="bold">Energie et Hydraulique</p>
                  </div>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-12 col-sm-4 col-lg-2">
                  <div class=" client-hover">
                    <p class="bold">Secteur Pétrolier et Minier</p>
                  </div>
                </div>

                <div class="col-12 col-sm-4 col-lg-2">
                  <div class=" client-hover">
                    <p class="bold">Banques/Finances</p>
                  </div>
                </div>
                <div class="col-12 col-sm-4 col-lg-2">
                  <div class=" client-hover">
                    <p class="bold">Industries</p>
                  </div>
                </div>
                <div class="col-12 col-sm-4 col-lg-2">
                  <div class=" client-hover">
                    <p class="bold" style="text-align: center;">Aéroportuaire</p>
                  </div>
                </div>
                <div class="col-12 col-sm-4 col-lg-2">
                  <div class=" client-hover">
                    <p class="bold">Agriculture</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="ett"
            style="padding: 50px 0px 20px; background: url('assets/img/back-about.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
            <div class="container">
              <div class="row">
                <div class="col-12 col-sm-7 col-lg-7 order-2" style="margin-top: 0px;">
                  <div>

                    <h2 class="customize-title" style="color: #00027d;">Le Chef de mission</h2>
                    <p>Gestionnaire d’entreprise, Psychologue du Travail et des Organisations bilingue, il
                      est depuis près de quinze ans Gérant
                      de la filiale du Groupe Talents Plus Afrique au Mali où il gère un effectif moyen de
                      250 personnes. Il est spécialisé
                      non seulement en audit, formation, étude et dialogue social mais également en
                      recrutement et assistance
                      RH/gestion/organisation.
                    </p>
                    <p style="font-weight: bold;">Avec vous, nous affinons notre expertise.</p>
                    <h3>RENE COMLAN TOHOUENOU</h3>
                    <div class="social-footer" style="margin-bottom: 40px;">
                      <a target="_blank" href="#"><img src="assets/img/linkdin_color.PNG" height="35"
                          style="margin-right: 20px;    fill: #FF5A00; "></a>
                      <a target="_blank" href="#"><img src="assets/img/mail.svg" height="40"></a>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-5 col-lg-5 order-1" style=""><img
                    style="width: 90%;    border-radius: 10%;margin-top: -8px;" src="assets/img/Mali.png"></div>
              </div>
            </div>
          </section>
          <app-confiance></app-confiance>
        </div>

        <!-- Content of menu 'talents-plus-conseils-cote-divoire' -->
        <div class="single-post" *ngIf="submenu == 'talents-plus-conseils-cote-divoire'">
          <!-- About Start -->
          <div class="container-xxl about " style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                        background-size: cover;">
            <div class="container">
              <div class="row g-0">
                <div class="col-lg-6">
                  <div class="h-100 d-flex align-items-center justify-content-center" style="min-height: 300px;">
                    <h1 class="customize-title" style="color: white;">Talents Plus Conseils Côte d'Ivoire </h1>
                  </div>
                </div>
                <div class="col-lg-6 pt-lg-3 mb-lg-5 wow fadeIn" data-wow-delay="0.5s">
                  <div class="bg-white rounded-top p-3 mt-lg-5">
                    <p class=" mb-2" style="font-size: 15px !important  ;">Créée en février 2014, TALENTS PLUS CONSEILS
                      Côte d'Ivoire
                      est spécialisé dans le conseil en management des Ressources Humaines et possède une expérience
                      prouvée
                      en matière de :</p>
                    <ul style="font-weight:bold;">
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Formations, renforcement des
                        capacités et Coaching </li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Recrutement </li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Portage </li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Mise à disposition de personnel de
                      </li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Externalisation</li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Assistance administrative et
                        organisationnelle</li>
                      <li><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Gestion Externalisée des
                        ressources humaines</li>
                      <li> <i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i>Etude et développement d’outils RH
                      </li>
                    </ul>
                    <p class=" mb-3" style="font-size: 15px !important  ;">Toutes prestations qui permettent aux
                      Organisations d’être compétitives, d’attirer et de fidéliser leurs ressources humaines.</p>
                    <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;"
                      href="contact/cote-d-ivoire">Contactez
                      nous</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- About End -->
          <section class="ett" style="margin:50px auto;">
            <div class="container">
              <div class="row">
                <div class="col-12 col-sm-7 col-lg-7 order-2" style="margin: auto;">
                  <div>

                    <h2 class="customize-title" style="color: #00027d;">A propos</h2>
                    <p style="text-align: justify;">La société Talents Plus Conseils Côte d’Ivoire (TPCI) a été créée
                      sous la forme d’une Société À
                      Responsabilité Limitée
                      (SARL). Elle est la quatrième filiale du Groupe TALENTS PLUS qui existe depuis
                      plus de 18 ans et compte
                      cinq (05) filiales principales et est, par ailleurs, membre du réseau Synergie Plus avec des
                      représentations au Burkina
                      Faso et au Sénégal, etc.</p>
                  </div>
                </div>
                <div class="col-12 col-sm-5 col-lg-5 order-1" style="margin: auto;"><img
                    style="width: 100%;    border-radius: 10%;" src="assets/img/abouts.jpg"></div>
              </div>
            </div>
          </section>
          <section class="about-section section-padding"
            style="padding: 20px 0px 20px; background: url('assets/img/back-about.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;"
            id="section_2">
            <div class="container">
              <div class="prix-filiale row">
                <div class="col-lg-6 col-12 mb-4 ">
                  <div class="services-info">
                    <p class="customize-title">Reconnaissances internationales</p>
                    <p class="text-blue" style="text-align: justify;">En 2008, le Cabinet s’est vu décerner à Genève
                      <span style="font-weight:bold;">le prix
                        ERA
                        international de la qualité et a vu sa position de leader en matière de management des
                        Ressources
                        Humaines confortée au Bénin et dans la sous-région.</span>
                    </p>
                    <p class="text-blue" style="text-align: justify;">En 2009, le <span style="font-weight:bold;">‘‘PRIX
                        DU MEILLEUR PRESTATAIRE DE
                        L’ANNÉE’’</span>
                      attribué par BRITISH AMERICAN TOBACCO.</p>

                    <p class="text-blue" style="text-align: justify;">En 2016, il a reçu <span
                        style="font-weight:bold;">le prix ‘’BEST HUMAN
                        RESSOURCES CONSULTING AGENCY
                        WEST AFRICA’’. Il s’agit du prix du meilleur Cabinet de Ressources Humaines de l’Afrique
                        l’Ouest.
                      </span></p>

                    <p class="text-blue " style="text-align: justify;">En 2018, Talents Plus Conseils a reçu <span
                        style="font-weight:bold;">le
                        prix de l’Entreprise la
                        plus dynamique du secteur de la GRH au Bénin et dans l’UEMOA’’.</span>
                      Ce leadership s’observe par la confiance que plusieurs structures dont de grandes institutions
                      internationales ont bien voulu placer en nous, en nous confiant la conduite de diverses missions.
                    </p>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="about-text-wrap">
                    <!-- <img src="assets/img/abouts.jpg" class="about-image img-fluid"> -->
                    <div class="">
                      <div class="ms-4">
                        <img src="assets/img/prix.jpg" alt="" style="width: 100% !important;">
                        <!-- <h3>a happy moment</h3>
                                    <p class="mb-0">your amazing festival experience with us</p> -->
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>

          <section
            style="padding: 20px 0px 60px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat; color: #fff;">

            <div class="container">
              <H2 class="customize-title" style="text-align: center;margin-bottom: 20px;">Domaines de compétences</H2>
              <div class="row">
                <div class="col-lg-4">
                  <ul style="font-weight:bold;">
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Recrutement complet</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Chasse de tête </li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Mise à disposition de
                      CVs</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Tests psychotechniques
                      électroniques</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Fiche de définition et
                      de description de poste</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Job family (famille de
                      métier): commercial, technicien, etc...</li>

                  </ul>
                </div>
                <div class="col-lg-4">
                  <ul style="font-weight:bold;">
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Système de motivation
                    </li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Rémunération : grille de
                      salaire, système de rémunération au rendement</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Système d’évaluation des
                      performances</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Système de développement
                      des compétences</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Système de gestion des
                      non performants</li>
                  </ul>
                </div>
                <div class="col-lg-4">
                  <ul style="font-weight:bold;">

                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Enquête de satisfaction
                      du personnel</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Audit social et
                      organisationnel</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Bilan social</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">Système de communication
                      interne</li>
                    <li><img src="assets/img/rh/check.png" class="list-check" alt="">GPEC</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <section class="ett" style="margin:50px auto;">
            <div class="container">
              <div class="row">
                <div class="col-12 col-sm-7 col-lg-7 order-2" style="margin-top: 50px;">
                  <div>

                    <h2 class="customize-title" style="color: #00027d;">Le chef de mission </h2>
                    <p style="text-align: justify;"> Diplômé de l'Université d'Abomey Calvi d'où il est sorti avec une
                      Maîtrise en Droit avec
                      spécialisation en Sciences
                      Politiques et Relations Internationales, Gustave HOUNKANNON est aussi titulaire d'un Diplôme
                      Supérieur Spécialisé en
                      Gestion, parcours Management des Ressources Humaines. Ces formations sont complétées par un Master
                      en Ingénierie des
                      Ressources Humaines obtenu au Centre Africain de Management et de Perfectionnement des Cadres
                      (CAMPC).
                      Collaborateur à Talents Plus Afrique depuis 2011 il est le chef de mission adjoint de la filiale
                      de la Côte d'Ivoire,
                      depuis 2014. Gestionnaire des Ressources Humaines, il est spécialiste de l'assistance à
                      l'externalisation en gestion
                      administrative du personnel, de la paie et en recrutement.
                    </p>
                    <p style="font-weight: bold;">Avec vous, nous affinons notre expertise.</p>
                    <h3>GUSTAVE HOUNKANNON</h3>
                    <div class="social-footer" style="margin-bottom: 40px;">
                      <a target="_blank" href="#"><img src="assets/img/linkdin_color.PNG" height="35"
                          style="margin-right: 20px;    fill: #FF5A00; "></a>
                      <a target="_blank" href="#"><img src="assets/img/mail.svg" height="40"></a>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-5 col-lg-5 order-1" style=""><img
                    style="width: 80%;    border-radius: 10%;margin-top: -8px;" src="assets/img/tpcci.png"></div>
              </div>
            </div>
          </section>

          <app-confiance></app-confiance>
        </div>

        <!-- Content of menu 'GISEA SARL' -->
        <div class="single-post" *ngIf="submenu == 'gisea-sarl'">

          <section class="produits"
            style="padding-top: 0px !important;background:url(assets/img/back-produits.svg); background-size: cover; background-position: center; background-repeat: no-repeat;">
            <div class="container ">
              <div style="text-align: center;">
                <img style="width: 18%" src="assets/img/gisea/gisea.png">
                <h2 class="customize-title" style="color: #00027d;">GISEA Sarl </h2>
                <p>GENIE INCENDIE SANTE ENERGIE AFRIQUE est une société filiale du Groupe <br> Talents plus Afrique crée
                  en
                  Mars 2018 ayant les compétences suivantes :</p>
              </div>
              <div class="row mt-15">
                <div class="col-lg-6 mt-5">
                  <div
                    style="background: linear-gradient(180deg, rgba(0, 0, 0, 0) 05%, #00027D 100%), url('assets/img/gisea/safty.jpg'); background-repeat: no-repeat;background-size: cover; background-position: center;">
                    <div class="disposition">
                      <h1 class="customize-title" style="color: white; font-weight: bold">
                        Expertise en santé et
                        sécurité au travail</h1>
                      <p style="color: white; font-size: 16px;">Avec la fourniture du matériel de sécurité incendie, la
                        maintenance de matériel, la formation,
                        l’élaboration et la mise
                        en place de divers plans et autres</p>
                    </div>
                  </div>

                </div>
                <div class="col-lg-6 mt-5">
                  <div
                    style="height:395px;background: linear-gradient(180deg, rgba(0, 0, 0, 0) 05%, #00027D 100%), url('assets/img/gisea/energy.jpg'); background-repeat: no-repeat;background-size: cover; background-position: center;">
                    <div class="disposition">
                      <h1 class="customize-title" style="color: white; font-weight: bold; ">
                        Environnement et Energie
                        :
                      </h1>
                      <p style="color: white; font-size: 16px;">Fourniture de matériel, formation, maintenance</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
          <section class="confiance">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-10">
                  <h2 class="customize-title"
                    style="text-align: center; margin-bottom: 50px; font-weight: bold; color: #00027D;">Ils nous font
                    confiance</h2>

                  <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                    <div class="carousel-inner">
                      <div class="carousel-item active">
                        <div class="row">
                          <div class="col"><img src="assets/img/logo/sodeco.jpg"
                              style="height: 100px; width: 128px; object-fit: contain; " alt="pnud logo"></div>
                          <div class="col"><img src="assets/img/logo/shb.png"
                              style="height: 100px; width: 128px; object-fit: contain; " alt="mtn logo"></div>
                          <div class="col"><img src="assets/img/logo/cbouclier.jpg"
                              style="height: 100px; width: 128px; object-fit: contain; " alt="bceao logo"></div>
                          <div class="col"><img src="assets/img/logo/incibe.jpg"
                              style="height: 100px; width: 128px; object-fit: contain; " alt="sotelma logo"></div>
                          <div class="col"><img src="assets/img/logo/cfao.png"
                              style="height: 100px; width: 128px; object-fit: contain; " alt="sotelma logo"></div>
                          <div class="col"><img src="assets/img/logo/sigh.png"
                              style="height: 100px; width: 128px; object-fit: contain; " alt="sotelma logo"></div>
                        </div>
                      </div>
                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                      <span class="sr-only">Next</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- infos -->
          <section class="contact"
            style="background: url('assets/img/mask-back.svg'); background-size: cover; background-position: center; background-repeat: no-repeat; padding: 50px 0px 0px 0px;">
            <div class="container">
              <div class="">
                <div class="row">
                  <div class="col-12 col-sm-4 col-lg-4" style="margin: auto;">
                    <h2 class="customize-title">Contactez-nous</h2>
                    <p>Nous sommes disponibles à tout moment pour tous vos besoins administratifs et professionnels.
                      Contactez-nous
                      maintenant</p>
                  </div>
                  <div class="col-12 col-sm-8 col-lg-8">
                    <div class="contact-card">
                      <!-- <h4 class="pays"><img src="assets/img/benin.svg">Bénin TCP</h4>
                    <hr> -->
                      <p><img src="assets/img/location.svg">Numéro IFU : 3201810249564</p>
                      <p><img src="assets/img/location.svg">Numéro RCM : RCCM-RB-COT-18-B-21101</p>
                      <p><img src="assets/img/local-phone.svg">(+229) 94 52 17 61</p>
                      <p><img src="assets/img/email.svg">info@mail.com</p>
                      <a target="_blank"
                        href="https://www.google.com/maps/place/GISEA/@6.3771197,2.3920657,15z/data=!4m5!3m4!1s0x0:0x6a7200796fe51d62!8m2!3d6.3771197!4d2.3920657">
                        <p><img src="assets/img/location.svg">Cliquez ici pour la localisation</p>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center pb-5">
                  <a href="contact/gisea-sarl" class="btn btn-submit-plus">Nous contacter</a>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- End blog-posts Area -->